import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DropdownModule } from 'primeng/dropdown';

import { ColourSelectComponent } from './colour-select.component';

/** Named-colour dropdown with swatches (#226/#227/#264). Its own module, like
 *  the target input, so any editor can use it without pulling in another. */
@NgModule({
  declarations: [ColourSelectComponent],
  imports: [CommonModule, FormsModule, DropdownModule],
  exports: [ColourSelectComponent],
})
export class ColourSelectModule {}
